import { memo, useEffect, useState } from "react";
import notificationApi from "../../api/notifications";
import { useApi } from "../../hooks/useApi";
import useTimer from "../../hooks/useTimer";
import { NotificationBanner } from "./NotificationBanner";

const NotificationsDisplay = () => {
  const timerValue = 60; //seconds
  const getActiveApi = useApi(notificationApi.getActive);
  const [notificationItems, setNotificationItems] = useState<any[]>([]);
  const { count, restartTimer } = useTimer(0);

  useEffect(() => {
    getActiveApi.request();
  }, []);

  useEffect(() => {
    if (
      getActiveApi.data &&
      JSON.stringify(notificationItems) !== JSON.stringify(getActiveApi.data.notifications)
    )
      setNotificationItems(getActiveApi.data.notifications);
  }, [getActiveApi.data]);

  useEffect(() => {
    if (count >= timerValue) {
      if (!getActiveApi.loading) getActiveApi.request();

      restartTimer();
    }
  }, [count]);

  return <NotificationBanner items={notificationItems} />;
};

export default memo(NotificationsDisplay);
